/**
 * Pre-compiled pt-BR messages for TagGroup
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { removeTag: `Remover tag` };
